import React, { createContext, useState, useContext, useCallback } from "react";

const LedgerStateContext = createContext();

export const useLedgerState = () => {
  const context = useContext(LedgerStateContext);
  if (!context) {
    throw new Error("useLedgerState must be used within LedgerStateProvider");
  }
  return context;
};

export const LedgerStateProvider = ({ children }) => {
  const [ledgerState, setLedgerState] = useState({
    activeTab: 0,
    individualLedger: null,
    subaccountLedger: null,
    partyClosingBalances: null,
    trialBalanceByGroup: null,
    cashBankBook: null,
    trialBalanceAll: null,
  });

  const updateTabState = useCallback((tabIndex, state) => {
    setLedgerState((prev) => ({
      ...prev,
      activeTab: tabIndex,
      ...(tabIndex === 0 && { individualLedger: state }),
      ...(tabIndex === 1 && { subaccountLedger: state }),
      ...(tabIndex === 2 && { partyClosingBalances: state }),
      ...(tabIndex === 3 && { trialBalanceByGroup: state }),
      ...(tabIndex === 4 && { cashBankBook: state }),
    }));
  }, []);

  const clearLedgerState = useCallback(() => {
    setLedgerState({
      activeTab: 0,
      individualLedger: null,
      subaccountLedger: null,
      partyClosingBalances: null,
      trialBalanceByGroup: null,
      cashBankBook: null,
      trialBalanceAll: null,
    });
  }, []);

  return (
    <LedgerStateContext.Provider
      value={{ ledgerState, updateTabState, clearLedgerState }}
    >
      {children}
    </LedgerStateContext.Provider>
  );
};
